module.exports = __webpack_public_path__ + "static/1-6d8e7bfb3d164d97a35b6dd23e435019.jpg";